import { selectCurrencyCode } from '@repo/api-adapters/selectors/customer-assets.selectors';
import { translate } from '@repo/phrase';

import { useAssetPriceTotals } from '@/hooks/asset-price-totals.hooks';
import { useAsset, useAssetParams } from '@/hooks/asset.hooks';
import { formatPrice } from '@/utils/translation.utils';
import { getAppConfig } from '@/utils/window.utils';

import type { PriceSummaryEntry } from './price-summary-overview.types';

export const usePriceSummaryOverviewTotalEntries = (): PriceSummaryEntry[] => {
    const { assetType, assetId } = useAssetParams();
    const { data } = useAsset(assetType, assetId);
    const currencyCode = selectCurrencyCode(data);
    const config = getAppConfig();
    const priceTotals = useAssetPriceTotals();
    const isPriceExcludingTaxEnabled = Boolean(config.feature.priceExclTax?.enable);

    return [
        {
            description: translate(
                isPriceExcludingTaxEnabled
                    ? 'summary_modal_article_table_total_excluding_tax'
                    : 'summary_modal_article_table_total'
            ),
            emphasized: true,
            id: 'summary_modal_article_table_total',
            shouldRender: true,
            value: formatPrice(priceTotals.totalOrderValue, currencyCode, {
                forceFixed: false,
            }),
        },
        {
            description: translate('asset_price_summary_pay_service'),
            id: 'asset_price_summary_pay_service',
            shouldRender: priceTotals.toServiceProviders > 0,
            value: formatPrice(priceTotals.toServiceProviders, currencyCode, { forceFixed: false }),
        },
        {
            description: translate('asset_price_summary_pay_ikea'),
            id: 'asset_price_summary_pay_ikea',
            shouldRender: priceTotals.toServiceProviders > 0,
            value: formatPrice(priceTotals.toIkea, currencyCode, { forceFixed: false }),
        },
        {
            description: translate('asset_price_summary_vat'),
            id: 'asset_price_summary_vat',
            shouldRender: !isPriceExcludingTaxEnabled,
            value: formatPrice(priceTotals.vatValue, currencyCode, { forceFixed: false }),
        },
    ];
};
